export const emailValid = (mailAddress) => {
  var regEmail = /^[A-Za-z0-9\u4e00-\u9fa5._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
  if (mailAddress !== '' && !regEmail.test(mailAddress)) {
    return false
  }
  return true
}

export const telValid = (value) => {
  const reg = /^((0\d{2,3}-_\d{7,8})|(1[34578]\d{9}))$/
  if (value === '' || value === undefined || value == null) {
    return false
  } else {
    if ((!reg.test(value))) {
      return false
    }
  }
  return true
}

export const getDateStringByDate = (d) => {
  // const date = new Date(parseInt(d))
  if (typeof d === 'string') {
    return d
  }
  const year = d.getFullYear()
  const month = d.getMonth() + 1
  const day = d.getDate()
  return `${year}-${month}-${day}`
}


// WEBPACK FOOTER //
// ./src/api/utils-api.js